import React from "react";

import Link from "@components/atoms/Link";

import { BreadcrumbsProps } from "./types";

const Breadcrumbs = ({ breadcrumbs }: BreadcrumbsProps) => {
  if (
    !breadcrumbs.length ||
    !breadcrumbs.every((item) => item.label)
  ) {
    return null;
  }

  return (
    <ul>
      {breadcrumbs.map((item) => {
        const { _uid, label = "", href } = item;
        const url =
          href?.url ||
          href?.cached_url ||
          href?.story?.full_slug ||
          "";

        if (!url && !label) return null;

        return (
          <li key={_uid}>
            {url ? (
              <Link href={url}>{label}</Link>
            ) : (
              <span>{label}</span>
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default Breadcrumbs;
